import React from 'react';
import { connect } from 'react-redux';

import { identifyIntercomUser, resetIntercom } from '../../utilities/intercom';
import { getUser } from '../Login/selectors';

class HeaderIntercom extends React.Component {
  componentDidMount() {
    identifyIntercomUser(this.props.user);
  }

  componentDidUpdate(prevProps) {
    const { user } = this.props;

    if ((!user || !user.id) && prevProps.user.id) {
      resetIntercom();
    }
  }

  render() {
    return <div />;
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: getUser(state),
});

export default connect(mapStateToProps)(HeaderIntercom);
